import { ReactComponent as ArrowLeft } from "app/assets/svg/arrow-left.svg"
import { ReactComponent as ArrowRight } from "app/assets/svg/arrow-right.svg"
import { useTranslate } from "hooks/translate"
import { useFormContext } from "react-hook-form"
import { useAppflow } from "app/hooks/useAppFlow"
import { ProductEnum } from "app/pages/appFlow/types"
import FormButton from "../Button"
import {
  StyledButtonLoadingIndicator,
  StyledButtonLoadingIndicatorWrapper,
  StyledFooter
} from "./style"

const Footer: React.FC<any> = ({ onPrev, numberOfSteps }) => {
  const { t } = useTranslate()
  const { goBack, step, bank, product } = useAppflow()
  const isLastStep = parseInt(step!, 10) === numberOfSteps
  const {
    formState: { isSubmitting }
  } = useFormContext()

  return (
    <StyledFooter>
      <FormButton
        key={`button-prev-${step}`}
        type="button"
        onClick={parseInt(step!, 10) > 1 ? onPrev : goBack}
        variant="text"
        icon={ArrowLeft}
        iconPlacement="prefix"
        action="prev"
      >
        {t("system.back")}
      </FormButton>
      {!((product === ProductEnum.Insurance || product === ProductEnum.Loa) && isLastStep) && (
        <FormButton
          key={`button-next-${step}`}
          icon={ArrowRight}
          iconPlacement="postfix"
          action="next"
          disabled={isSubmitting || (parseInt(step!, 10) === 1 && !bank)}
        >
          {isSubmitting && (
            <StyledButtonLoadingIndicatorWrapper>
              <StyledButtonLoadingIndicator />
            </StyledButtonLoadingIndicatorWrapper>
          )}
          {t(isLastStep ? "system.complete" : "system.next")}
        </FormButton>
      )}
    </StyledFooter>
  )
}

export default Footer
